/**
 * TCS education panels — collection discovery anchors.
 * - Smooth scroll only when motion is allowed
 * - Opens the target outer <details> and focuses its summary
 * - Anchors remain usable without this script (native fragment nav)
 * - Idempotent: Theme Editor section reloads / duplicate script tags are safe
 */
(function (window, document) {
  if (window.__tcsEducationBound) return;
  window.__tcsEducationBound = true;

  function motionAllowed() {
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function openAndFocusPanel(panel) {
    if (!panel) return;
    var outer = panel.querySelector('[data-tcs-education-outer]');
    if (outer && !outer.open) {
      outer.open = true;
    }
    var summary = panel.querySelector('.tcs-education-panel__summary');
    if (!summary) return;
    // Native <summary> is already in the tab order; do not set tabindex="-1"
    // (that would remove it from subsequent Tab navigation).
    try {
      summary.focus({ preventScroll: true });
    } catch (e) {
      summary.focus();
    }
  }

  function resolvePanelFromHash() {
    var id = window.location.hash.replace(/^#/, '');
    if (!id) return null;
    var el = document.getElementById(id);
    if (!el) return null;
    if (el.classList.contains('tcs-education-panel')) return el;
    return el.querySelector('.tcs-education-panel');
  }

  function handleHashTarget() {
    var panel = resolvePanelFromHash();
    if (!panel) return;
    openAndFocusPanel(panel);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-tcs-education-anchor]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var id = href.slice(1);
    var target = document.getElementById(id);
    if (!target) return;
    var panel = target.classList.contains('tcs-education-panel')
      ? target
      : target.querySelector('.tcs-education-panel');
    if (!panel) return;

    event.preventDefault();
    openAndFocusPanel(panel);

    if (motionAllowed()) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      panel.scrollIntoView({ behavior: 'auto', block: 'start' });
    }

    if (history.replaceState) {
      history.replaceState(null, '', '#' + id);
    } else {
      window.location.hash = id;
    }
  });

  function promoteBoldHeadings(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var paragraphs = scope.querySelectorAll(
      '.tcs-education-panel__item-body p, .tcs-spec-note__body p'
    );
    paragraphs.forEach(function (paragraph) {
      var nodes = Array.prototype.filter.call(paragraph.childNodes, function (node) {
        return node.nodeType !== 3 || node.textContent.trim() !== '';
      });
      if (nodes.length !== 1) return;
      var strong = nodes[0];
      if (!strong || strong.tagName !== 'STRONG') return;
      if (strong.textContent.trim() !== paragraph.textContent.trim()) return;
      var heading = document.createElement('h3');
      heading.className = 'tcs-education-panel__inline-heading';
      heading.innerHTML = strong.innerHTML;
      paragraph.replaceWith(heading);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    promoteBoldHeadings(document);
    handleHashTarget();
  });
  window.addEventListener('hashchange', handleHashTarget);
  window.addEventListener('popstate', handleHashTarget);

  document.addEventListener('shopify:section:load', function (event) {
    promoteBoldHeadings(event.target);
    handleHashTarget();
  });
})(window, document);
